import { render, staticRenderFns } from "./ShopMallInfo.vue?vue&type=template&id=2ec622d8&scoped=true"
import script from "./ShopMallInfo.vue?vue&type=script&lang=ts"
export * from "./ShopMallInfo.vue?vue&type=script&lang=ts"
import style0 from "./ShopMallInfo.vue?vue&type=style&index=0&id=2ec622d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec622d8",
  null
  
)

export default component.exports